import ModalService from '@/modules/core/ui/services/ModalService';
import ConfirmModal from '@/modules/core/ui/components/ConfirmModal.vue';
import EventBus from '@/modules/core/app/helpers/EventBus';
import { AuthMismatchEvent } from '@/modules/auth/constants/AuthMismatchEvent';

export const DetectAuthSessionMismatchMixin = {
  mounted() {
    EventBus.listenOnce(AuthMismatchEvent.TOKEN_MISMATCH, this.authMismatchHandler);
  },
  methods: {
    authMismatchHandler() {
      ModalService.show({
        parent: this,
        component: ConfirmModal,
        canCancel: false,
        props: {
          title: this.$t('auth.session-mismatch-title'),
          subtitle: this.$t('auth.session-mismatch-subtitle'),
          primaryButtonText: this.$t('auth.session-mismatch-confirm'),
          hideCancel: true,
          confirmFn: () => {
            document.location.reload();
          }
        }
      });
    }
  },
  beforeUnmount() {
    EventBus.destroy(AuthMismatchEvent.TOKEN_MISMATCH, this.authMismatchHandler);
  }
};
